import React, { useEffect, useState } from 'react'
import { UserProfile } from '../../../models/UserProfile'
import { getProfile, updateProfile } from '../../../networking/network'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { setProfile } from '../../../store/user/userSlice'
import { useForm, Controller } from 'react-hook-form'
import { Box, Button, CircularProgress, TextField } from '@mui/material'

const ProfileView = () => {
  const { control, handleSubmit } = useForm()
  
  const dispatch = useAppDispatch()
  const accessToken = useAppSelector(state => state.user.token)
  const userProfile = useAppSelector(state => state.user.profile)

  const [isLoading, setIsLoading] = useState(true)

  const handleFormSubmit = (data: any) => {
    if (!accessToken) {
      return
    }

    const uploadProfile = async () => {
      setIsLoading(true)
      const upload: UserProfile = Object.assign({}, userProfile)
      if (data.first_name) {
        upload.first_name = data.first_name
      }

      if (data.last_name) {
        upload.last_name = data.last_name
      }
      const updated = await updateProfile(accessToken, upload)
      dispatch(setProfile(updated))
      setIsLoading(false)
    }

    uploadProfile()
  }

  useEffect(() => {
    if (!accessToken) {
      return
    }

    const refreshProfile = async () => {
      setIsLoading(true)
      const profile = await getProfile(accessToken)
      setProfile(profile as UserProfile)
      setIsLoading(false)
    }
    refreshProfile()
  }, [])

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
        <Box display='flex' flexDirection='row' alignItems='top' justifyContent='center'>
          <Box display='flex' alignItems='center' flexDirection='column' sx={{
            width: '500px',
            m: 2
          }}>
            {isLoading &&
              <CircularProgress />
            }
            {!isLoading &&
            <React.Fragment>
              <Controller 
                  name='first_name'
                  control={control}
                  defaultValue={userProfile?.first_name || ''}
                  render={({ field: { onChange, value }, fieldState: { error } }) => 
                    <TextField 
                      value={value} 
                      onChange={onChange} 
                      variant='outlined' 
                      error={!!error}
                      helperText={error ? error.message : null}
                      label='First Name' sx={{
                        m: 1,
                        width: '100%'
                      }} /> 
                  }
                />
                <Controller 
                  name='last_name'
                  control={control}
                  defaultValue={userProfile?.last_name || ''}
                  render={({ field: { onChange, value }, fieldState: { error } }) => 
                    <TextField 
                      value={value} 
                      onChange={onChange} 
                      variant='outlined' 
                      error={!!error}
                      helperText={error ? error.message : null}
                      label='Last Name' sx={{
                        m: 1,
                        width: '100%'
                      }} /> 
                  }
                />
                <Button type='submit' variant='contained' sx={{
                  m: 1,
                  width: '300px'
                }}>Submit</Button>
              </React.Fragment>
            }
          </Box>
          </Box>
        </Box>
      </form>
    </React.Fragment>
  )
}

export default ProfileView
